<div class="container mt-4">
  <div class="form-group">
    <label>Short Code</label>
    <input class="form-control" [(ngModel)]="shortcode" [readonly]="isEditMode" />
  </div>
  <div class="form-group">
    <label>Description</label>
    <input class="form-control" [(ngModel)]="description" />
  </div>
  <div class="form-check" *ngIf="!isEditMode">
    <input class="form-check-input" type="checkbox" [(ngModel)]="useExistingProperties" />
    <label class="form-check-label">Use Property Array from existing template</label>
  </div>
  <div class="form-group" *ngIf="useExistingProperties && !isEditMode">
    <label>Select Template</label>
    <select class="form-control" [(ngModel)]="selectedTemplate">
      <option value="">-- Select template --</option>
      <option *ngFor="let template of templates" [value]="template.MTShortCode">
        {{ template.MTShortCode }} — {{ template.MTDescription }}
      </option>
    </select>
  </div>
  <button class="btn btn-success" (click)="save()">Save</button>
</div>
